/**
 * @generated SignedSource<<c55148bd47df6cdf03747102e5190fbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolBalanceFragment$data = {
  readonly account: string;
  readonly availableYieldLp: {
    readonly amount: bigint;
    readonly asset: {
      readonly asset: string;
      readonly metadata: {
        readonly symbol: string;
      };
    };
    readonly valueUsd: bigint;
  };
  readonly availableYieldXlp: {
    readonly amount: bigint;
    readonly asset: {
      readonly asset: string;
    };
    readonly valueUsd: bigint;
  };
  readonly id: string;
  readonly lpShares: bigint;
  readonly lpSize: {
    readonly amount: bigint;
    readonly asset: {
      readonly metadata: {
        readonly symbol: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"msgAssetFragment">;
    };
    readonly valueUsd: bigint;
  };
  readonly xlpShares: bigint;
  readonly xlpSize: {
    readonly amount: bigint;
    readonly asset: {
      readonly metadata: {
        readonly symbol: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"msgAssetFragment">;
    };
    readonly valueUsd: bigint;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceReinvestFragment" | "PerpsPoolBalanceWithdrawFragment">;
  readonly " $fragmentType": "PerpsPoolBalanceFragment";
};
export type PerpsPoolBalanceFragment$key = {
  readonly " $data"?: PerpsPoolBalanceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUsd",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Asset",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "msgAssetFragment"
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asset",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerpsPoolBalanceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "account",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "lpSize",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lpShares",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "xlpSize",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "xlpShares",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "availableYieldLp",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "availableYieldXlp",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PerpsPoolBalanceReinvestFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PerpsPoolBalanceWithdrawFragment"
    }
  ],
  "type": "PerpsAccount",
  "abstractKey": null
};
})();

(node as any).hash = "c9dbeae552c07ed7f44b074882d04b89";

export default node;
